<template>
  <div class="top-left w50 right margin margin_r_hf margin_l_c">
    <!--    <div class="tempLikeViki">    </div>-->
    <div class="styleCard">
      <div class="menu-wrapper">
        <ul class="sub-menu-dropup">
          <li
            class="dropdown-item btn btn-block btn-light-gray"
            v-for="tab in camTabs"
            :key="tab"
            :class="{
              active: selectedTab === tab.alias.toUpperCase()
            }"
            @click="setClickFromMenu(tab.alias.toUpperCase())"
          >
            <span>
              <i class="fas fa-caret-left"></i>
            </span>
            <span class="tabName"> {{ tab.name }}</span>
          </li>
        </ul>
      </div>
      <div class="sysChatContentTemp">
        <div
          class="styleCardContent padding"
          v-if="selectedTab !== 'IMPRESSIONS' && camTabs !== 'GAMES'"
        ></div>
        <div
          class="styleCardContentChart flex"
          v-if="
            CheckUserPermission([1, 2, 3, 4, 5, 12]) &&
              selectedTab === 'IMPRESSIONS'
          "
        >
          <ul class="new-nav style4" v-if="selectedTab === 'IMPRESSIONS'">
            <li
              v-for="range in timeRanges"
              :key="range.id"
              id="range.name"
              :class="{ active: selectedTimeRange === range.alias }"
              @click="selectedTimeRange = range.alias"
            >
              {{ range.name }}
              <span
                v-if="countAgents && selectedTimeRange === range.alias"
                class="total_Counter"
              >
                {{ countAgents }}
                {{ "|" }}
                <span class="c2c-counter">
                  {{ countC2C }}
                </span>
              </span>
            </li>
          </ul>
          <div class="main-chart" id="imp-chart-cam"></div>
        </div>
        <div class="styleCardContentChart flex" v-if="selectedTab === 'GAMES'">
          <ul class="date-nav style3">
            <li
              v-for="tab in timeRangesForGames"
              :key="tab.id"
              :class="{ active: selectedGame === tab.alias }"
              @click="
                () => {
                  selectedGame = tab.alias;
                }
              "
            >
              {{ tab.name }}
            </li>
          </ul>
          <div class="forGame" v-if="CheckUserPermission([1, 2, 3, 4, 5, 12])">
<!--            <button class="for-close" @click="selectedTab = 'IMPRESSIONS'">-->
<!--              X-->
<!--            </button>-->
           <i class="fa fa-times" @click="selectedTab = 'IMPRESSIONS'"></i>
            <snake v-if="selectedGame === 'SNAKE'" />
          </div>
        </div>
        <FbChat v-if="selectedTab === 'CHAT'" />
      </div>

      <!--      <ul class="style-nav style2">-->
      <!--        <li-->
      <!--          v-for="tab in camTabs"-->
      <!--          :key="tab.id"-->
      <!--          :class="{ active: selectedCamTab === tab.alias }"-->
      <!--          @click="selectedCamTab = tab.alias"-->
      <!--        >-->
      <!--          {{ tab.name }}-->
      <!--        </li>-->
      <!--      </ul>-->

      <!--      <div-->
      <!--        class="styleCardContent padding"-->
      <!--        v-if="selectedCamTab !== 'IMPRESSIONS' && selectedCamTab !== 'GAMES'"-->
      <!--      ></div>-->

      <!--      <div-->
      <!--        class="styleCardContentChart flex"-->
      <!--        v-if="-->
      <!--          selectedCamTab === 'IMPRESSIONS' &&-->
      <!--            checkPermissions(auth, [1, 2, 3, 4, 5, 12])-->
      <!--        "-->
      <!--      >-->

      <!--        <ul class="new-nav style4" v-if="selectedCamTab === 'IMPRESSIONS'">-->
      <!--          <li-->
      <!--            v-for="range in timeRanges"-->
      <!--            :key="range.id"-->
      <!--            id="range.name"-->
      <!--            :class="{ active: selectedTimeRange === range.alias }"-->
      <!--            @click="selectedTimeRange = range.alias"-->
      <!--          >-->
      <!--            {{ range.name }}-->
      <!--            <span-->
      <!--              v-if="countAgents && selectedTimeRange === range.alias"-->
      <!--              class="total_Counter"-->
      <!--            >-->
      <!--              {{ countAgents }}-->
      <!--              {{ "|" }}-->
      <!--              <span class="c2c-counter">-->
      <!--                {{ countC2C }}-->
      <!--              </span>-->
      <!--            </span>-->
      <!--          </li>-->
      <!--        </ul>-->

      <!--        <div class="main-chart" id="imp-chart-cam"></div>-->
      <!--      </div>-->

      <!--      <div class="styleCardContentChart flex" v-if="selectedCamTab === 'GAMES'">-->
      <!--        <ul class="date-nav style3">-->
      <!--          <li-->
      <!--            v-for="tab in timeRangesForGames"-->
      <!--            :key="tab.id"-->
      <!--            :class="{ active: selectedGame === tab.alias }"-->
      <!--            @click="-->
      <!--              () => {-->
      <!--                selectedGame = tab.alias;-->
      <!--              }-->
      <!--            "-->
      <!--          >-->
      <!--            {{ tab.name }}-->
      <!--          </li>-->
      <!--        </ul>-->
      <!--        <div class="forGame" v-if="checkPermissions(auth, [1, 2, 3, 4, 5, 12])">-->
      <!--          <snake v-if="selectedGame === 'SNAKE'"></snake>-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
  </div>
</template>
<script>
import apiClientCreator from "../../../helpers/api/request";
import { mapGetters, mapState } from "vuex";
import moment from "moment";

import Snake from "../../games.feature/shortcuts.games/snake.game/containers/Snake.container";
import FbChat from "../../chat.feature/containers/FacebookMessengerChat.container";
import UsersPermissionCheck from "../../../mixins/user/auth/UsersPermissionCheck";

export default {
  name: "SecurityCams.container",
  components: { Snake, FbChat },
  computed: {
    ...mapGetters("clients", ["loading"]),
    ...mapState("user", ["auth"]),
    ...mapGetters("user", ["isLogged"]),
    ...mapGetters("main", ["showVikiMsg"]),
    ...mapState("main", ["showVikiMsg"]),
    ...mapState("clients", [
      "dictionaries",
      "salesPersonList",
      "chartsMainView",
      "campChartData",
      "CountriesMainChartData",
      "chartsViewBlocks",
      "multiSelectChartData",
      "loading"
    ])
  },
  mixins: [UsersPermissionCheck],
  data() {
    return {
      camTabs: [
        {
          id: 1,
          name: "COUNT",
          alias: "IMPRESSIONS"
        },
        {
          id: 2,
          name: "GAMES",
          alias: "GAMES"
        },
        {
          id: 3,
          name: "FB CHAT",
          alias: "CHAT"
        }
        // {
        //   id: 4,
        //   name: "CAMERA 3",
        //   alias: "CAMERA_C"
        // },
        // {
        //   id: 5,
        //   name: "CAMERA 4",
        //   alias: "CAMERA_D"
        // }
      ],
      selectedTab: "IMPRESSIONS",
      // selectedCamTab: "IMPRESSIONS",
      timeRangesForGames: [
        {
          id: 1,
          name: "SNAKE",
          alias: "SNAKE"
        }
        // {
        //   id: 2,
        //   name: "",
        //   alias: ""
        // },
        // {
        //   id: 3,
        //   name: "",
        //   alias: ""
        // },
        // {
        //   id: 4,
        //   name: "",
        //   alias: ""
        // },
        // {
        //   id: 5,
        //   name: "",
        //   alias: ""
        // },
        // {
        //   id: 6,
        //   name: "",
        //   alias: ""
        // },
        // {
        //   id: 7,
        //   name: "",
        //   alias: ""
        // },
        // {
        //   id: 8,
        //   name: "",
        //   alias: ""
        // },
        // {
        //   id: 8,
        //   name: "",
        //   alias: ""
        // }
      ],
      timeRanges: [
        {
          id: 1,
          name: "10M",
          alias: "10M",
          range: {
            type: "m",
            value: 10
          }
        },
        {
          id: 2,
          name: "30M",
          alias: "30M",
          range: {
            type: "m",
            value: 30
          }
        },
        {
          id: 3,
          name: "1H",
          alias: "1H",
          range: {
            type: "h",
            value: 1
          }
        },
        {
          id: 4,
          name: "4H",
          alias: "4H",
          range: {
            type: "h",
            value: 4
          }
        },
        {
          id: 5,
          name: "1D",
          alias: "1D",
          range: {
            type: "d",
            value: 1
          }
        },
        {
          id: 6,
          name: "1W",
          alias: "1W",
          range: {
            type: "w",
            value: 1
          }
        }
      ],
      selectedTimeRange: "10M",
      linkBuilder: null,
      ArImpData: [],
      interval: null,
      countAgents: null,
      countC2C: null,
      selectedDateRange: "TODAY",
      selectedGame: "SNAKE"
    };
  },
  mounted() {
    if (this.checkPermissions(this.auth, [1, 2, 3, 4, 5, 12])) {
      this.timeRanges.reverse();
      this.interval = setInterval(() => {
        this.fetchDataToChart();
      }, 600000);
      this.fetchDataToChart();
    }
  },

  watch: {
    selectedTimeRange: function() {
      if (this.checkPermissions(this.auth, [1, 2, 3, 4, 5, 12])) {
        this.interval = setInterval(() => {
          this.fetchDataToChart();
        }, 600000);
        this.fetchDataToChart();
      }
    },
    selectedTab: function() {
      if (this.checkPermissions(this.auth, [1, 2, 3, 4, 5, 12])) {
        if (this.selectedTab === "IMPRESSIONS") {
          this.fetchDataToChart();
        } else {
          this.interval = clearInterval(this.interval);
        }
      }
    }
  },
  methods: {
    setClickFromMenu(tab) {
      // let tempObj = Object.assign({}, this.chartsViewBlocks);
      // tempObj[4] = tab;
      // this.$store.commit("clients/setChartsViewBlocks", tempObj);
      this.selectedTab = tab;
    },

    namesFormatter(name, numLet = 10) {
      let first_name = name.split(" ")[0].substring(0, numLet);
      let second_name = "";
      name.split(" ").length > 1
        ? (second_name = name
            .split(" ")[1]
            .substring(0, 1)
            .toUpperCase())
        : (second_name = "");
      let fullName = first_name + " " + second_name;
      return fullName;
    },
    defaultPresets(range = this.selectedDateRange) {
      if (range === "TODAY") {
        const today = moment().format("YYYY-MM-DD");
        return {
          dateRange: {
            start: today,
            end: today
          }
        };
      }
      if (range === "YESTERDAY") {
        const start = moment()
          .subtract(1, "days")
          .format("YYYY-MM-DD");
        // const end = new Date(Date.UTC(n.getFullYear(), n.getMonth(), n.getDate()))
        return {
          dateRange: {
            start: start,
            end: start
          }
        };
      }
      if (range === "WEEK") {
        const n = new Date();
        const start = moment()
          .startOf("isoWeek")
          .format("YYYY-MM-DD");

        const end = moment().format("YYYY-MM-DD");

        return {
          dateRange: {
            start: start,
            end: end
          }
        };
      }
      if (range === "LAST_WEEK") {
        const start = moment()
          .subtract(1, "weeks")
          .startOf("week")
          .format("YYYY-MM-DD");
        const end = moment()
          .subtract(1, "weeks")
          .endOf("week")
          .format("YYYY-MM-DD");
        return {
          dateRange: {
            start: start,
            end: end
          }
        };
      }
      if (range === "MONTH") {
        const startMonth = moment()
          .startOf("month")
          .format("YYYY-MM-DD");
        const endMonth = moment().format("YYYY-MM-DD");
        return {
          dateRange: {
            start: startMonth,
            end: endMonth
          }
        };
      }
      if (range === "LAST_MONTH") {
        const startMonth = moment()
          .subtract(1, "months")
          .startOf("month")
          .format("YYYY-MM-DD");
        const endMonth = moment()
          .subtract(1, "months")
          .endOf("month")
          .format("YYYY-MM-DD");
        return {
          dateRange: {
            start: startMonth,
            end: endMonth
          }
        };
      }
      if (range === "LAST_30_DAYS") {
        const start = moment()
          .subtract(30, "days")
          .format("YYYY-MM-DD");
        const end = moment().format("YYYY-MM-DD");
        return {
          dateRange: {
            start: start,
            end: end
          }
        };
      }
      if (range === "QUARTER") {
        const start = moment()
          .startOf("quarter")
          .format("YYYY-MM-DD");
        const end = moment().format("YYYY-MM-DD");
        return {
          dateRange: {
            start: start,
            end: end
          }
        };
      }
      if (range === "HALF_YEAR") {
        const start = moment()
          .subtract(6, "months")
          .format("YYYY-MM-DD");
        const end = moment().format("YYYY-MM-DD");
        return {
          dateRange: {
            start: start,
            end: end
          }
        };
      }
      if (range === "YEAR") {
        const start = moment()
          .subtract(1, "year")
          .format("YYYY-MM-DD");
        const end = moment().format("YYYY-MM-DD");
        return {
          dateRange: {
            start: start,
            end: end
          }
        };
      }
    },
    getLink() {
      let tempObj = this.timeRanges.filter(
        a => a.alias === this.selectedTimeRange
      );
      this.linkBuilder = `client/stats/impression/${tempObj[0].range.type}/${tempObj[0].range.value}`;
      return this.linkBuilder;
    },

    fetchDataToChart() {
      if (this.$router.currentRoute.name === "Main") {
        if (this.checkPermissions(this.auth, [1, 2, 3, 4, 5, 12])) {
          this.ArImpData = [];
          let canvasId = "imp-chart-cam";
          apiClientCreator(this.getLink())
            .get("", {})
            .then(res => {
              this.ArImpData = [];
              this.ArImpData = res.data;
              if (this.ArImpData.length > 0) {
                this.countAgents = this.ArImpData.filter(
                  agent => agent.c2c > 0
                ).length;
                this.countC2C = this.ArImpData.reduce((a, b) => a + b.c2c, 0);
              } else {
                this.ArImpData = null;
                this.countC2C = null;
              }
              if (res.data.length > 0) {
                this.createImpChart(canvasId, this.ArImpData);
              }
            });
        }
      }
    },

    createImpChart(canvasId, chartData) {
      if (this.$router.currentRoute.name === "Main") {
        $("#" + canvasId).html("");
        let set = [];

        chartData.sort((a, b) => {
          if (a.c2c > b.c2c) {
            return -1;
          }
          if (a.c2c < b.c2c) {
            return 1;
          }
          return 0;
        });

        chartData.map(item => {
          if (item.c2c === 0) {
            return;
          }
          set.push([this.namesFormatter(item.user.full_name), item.c2c]);
        });

        let chart = anychart.column();
        let series = chart.column(set);
        let yScale2 = anychart.scales.linear();
        yScale2.stackMode("value");
        // turn on chart animation
        chart.animation(true);

        // set container id for the chart
        chart.container(canvasId);
        //chart.padding([10, 40, 5, 20]);

        // set scale minimum
        chart.yScale().minimum(0);
        //chart.yScale().labels()

        // force chart to stack values by Y scale.
        chart.yScale().stackMode("value");

        chart
          .yAxis()
          .labels()
          .format(function() {
            return this.value.toLocaleString();
          });

        // helper function to setup label settings for all series
        let setupSeriesLabels = function(series, name) {
          series.name(name);
          series.stroke("0 #fff 0");
          series.hovered().stroke("0 #fff 0");
        };
        chart
          .xAxis()
          .labels()
          .format(function() {
            let value = this.value;
            return value;
          });
        chart
          .xAxis()
          .labels()
          .fontSize(9);
        chart
          .xAxis()
          .labels()
          .padding(-0.5);

        chart.barsPadding(-0.5);
        let legend = chart.legend();
        // enable legend
        legend.enabled(false);
        // temp variable to store series instance
        //let series;
        //
        //let c2c = chart.column(series);
        setupSeriesLabels(series, "C2C");
        series.normal().fill("#212121", 0.8);

        // turn on legend
        //chart.legend().enabled(true).fontSize(10).padding([0, 0, 10, 0]);
        chart.interactivity().hoverMode("by-x");
        chart.barGroupsPadding(0);
        chart.tooltip().displayMode("union");
        let yLabels = chart.yAxis().labels();
        yLabels.fontSize(8);
        // initiate chart drawing
        chart.draw();

        let credits = document.getElementsByClassName("anychart-credits");
        $(credits).hide();
      }
    },

    checkPermissions(user, permitted) {
      return permitted.some(role => role === user.user.role);
    }
  }
};
</script>

<style scoped>
.w50 {
  width: calc(45%);
  /*width: calc(50%);*/
}
.right {
  float: right;
}
.margin {
  /*margin: 0.5rem;*/
}
.margin_r_hf {
  /*margin-right: 0;*/
}
.margin_l_c {
  /*margin-left: 0.2rem;*/
}
.styleCard {
  /*box-shadow: 0px 9px 20px rgba(0, 0, 0, 0.05);*/
  border-radius: 5px;
  height: 100%;
  /*height: 212px;*/
  font-family: Montserrat;
  padding-left: 12px;
  padding-top: 12px;
}

.style-nav {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  position: relative;
  /*
    background: white;
  */
}
.style-nav.style2 li {
  /*border-radius: 5px 5px 0px 0px;*/
  transition: transform 0.1s ease;
}
.style-nav.style2 li:not(:last-child) {
  margin-right: 2px;
}

.style-nav li {
  max-width: 264px;
  min-width: 72px;
  height: 30px;
  margin: 0;
  cursor: pointer;
  background: white;
  border-radius: 0;
  font-size: 12px;
  text-align: center;
  vertical-align: middle;
  line-height: 30px;
  border-bottom: 2px solid transparent;
  flex-grow: 1;
  transition: background 0.2s ease, color 0.2s ease;
}

.style-nav.style2 li:not(.empty):hover {
  transform: translateY(5px);
}

.style-nav.style2 li.active {
  border-bottom: 2px solid #44a2d2 !important;
  color: #44a2d2;
}

.style-nav.style1 li:not(.empty):hover {
  background: #44a2d2;
  color: white;
}

.style-nav.style1 li.active {
  border-bottom: 2px solid #44a2d2 !important;
  background: #44a2d2;
  color: white;
}
/*.styleCardContent {*/
/*  background: white;*/
/*  min-height: 12rem;*/
/*  height: 100%;*/
/*}*/
.styleCardContentChart {
  background: white;
  min-height: 12rem;
  height: 89%;
  padding: 12px;
  border: 2px solid #a6a6a673;
  border-radius: 12px;
}
/*.padding {*/
/*  padding: 1rem;*/
/*}*/
.main-chart {
  width: 100%;
  height: 100%;
}
.flex {
  display: flex;
  align-items: stretch;
  background-color: #fff;
  min-width: 96%;
  min-height: 100%;
}

.date-nav {
  max-width: 5%;
  max-height: 90%;
  min-height: 90%;
  margin: 0;
  padding: 0;
  /*padding-top: 60px;*/
  list-style: none;
  display: flex;
  flex-direction: column;
  position: relative;
  background: white;
  flex: 1;
}

.date-nav.style3 li {
  max-height: 10%;
  border-radius: 5px 5px 0px 0px;
  transition: transform 0.1s ease;
  display: flex;
  /*justify-content:center;*/
  align-items: center;
}

.date-nav.style3 li:not(:last-child) {
  /*margin-right: 2px;*/
}

.date-nav li {
  max-width: 3%;
  min-width: 100%;
  max-height: 10%;
  margin: 0;
  cursor: pointer;
  background: white;
  border-radius: 0;
  font-size: 10px;
  text-align: left;
  vertical-align: middle;
  /*line-height: 25px;*/
  border-bottom: 2px solid transparent;
  flex-grow: 1;
  transition: background 0.2s ease, color 0.2s ease;
  margin-left: 3px;
}

.date-nav li:not(.empty):hover {
  transform: translateY(1px);
}

.date-nav li.active {
  border-bottom: 1px solid #44a2d2 !important;
  color: #44a2d2;
}
.forGame {
  /*width: 863px;*/
  /*height: 227px;*/
  /*position: absolute;*/
  /*right: 35px;*/
  width: 87%;
  height: 90%;
  position: absolute;
  right: 35px;
}
.Counters_wraper {
  position: absolute;
  display: flex;
  flex-direction: column;
  right: -858px;
  top: 8px;
  z-index: 30;
}
.total_Counter {
  font-size: 8px;
  font-weight: bold;
  /*margin-right: 10px;*/
}

.new-nav {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column-reverse;
  position: relative;
  /*
    background: white;
  */
}
.new-nav.style4 li {
  /*border-radius: 5px 5px 0px 0px;*/
  transition: transform 0.1s ease;
}
.new-nav.style4 li:not(:last-child) {
  margin-right: 2px;
}

.new-nav li {
  max-width: 264px;
  min-width: 72px;
  height: 20px;
  margin: 0;
  cursor: pointer;
  background: white;
  border-radius: 0;
  font-size: 12px;
  /* text-align: center;*/
  vertical-align: middle;
  /*line-height: 40px;*/
  border-bottom: 2px solid transparent;
  flex-grow: 1;
  transition: background 0.2s ease, color 0.2s ease;
}

/*.new-nav.style4 li:not(.empty):hover {*/
/*  transform: translateY(1px);*/
/*}*/

/*.new-nav.style4 li.active {*/
/*  border-bottom: 2px solid #44a2d2 !important;*/
/*  color: #44a2d2;*/
/*}*/

.new-nav.style4 li:not(.empty):hover {
  /*
  background: #44a2d2;
*/
  color: #277aa5;
  font-size: 12px;
}
.c2c-counter {
  color: #00a700;
}
.tempLikeViki {
  width: 180px;
  height: 197px;
  border: 1px solid black;
}

/*////*/
.menu-wrapper {
  /*overflow-x: visible;*/
  /*display: flex;*/
  /*justify-content: space-between;*/
  /*flex-direction: column;*/
  /*border: 1px solid black;*/
  float: right;
  /*position: relative;*/
  top: 5px;
  border-radius: 12px;
  /*padding-top: 12px;*/
  padding-right: 12px;
  /*padding-bottom: 12px;*/
  padding-left: 12px;
}
.sub-menu-dropup {
  left: -9px;
  bottom: 22px;
  /* z-index: 1000; */
  /* display: none; */
  /* float: left; */
  min-width: 115px;
  border-radius: 0px;
  padding: 0px;
  max-height: 160px;
  min-height: 160px;
  text-transform: uppercase;
}
.dropdown-item {
  height: 35px;
  min-height: 8%;
  /*padding: 1px 0px;*/
  /*margin: 0px;*/
  border-radius: 0px;
  outline: none;
  font-size: 12px;
  display: flex;
  text-align: left;
  transition: all 0.3s ease-in-out;
  border-radius: 5px 0px 0px 5px;
  //margin-bottom: 1px;
  background-color: white;
  border: 1px solid #d7d7d7;
  position: relative;
  z-index: 1;
}
.dropdown-item:focus {
  outline: none;
}
.dropdown-item:hover {
  transform: translateX(-7px);
  border-radius: 5px 0px 0px 5px;
}
.sub-menu-dropup li.active {
  background-color: #c12fff;
  color: #fff;
}
span.tabName {
  padding-left: 10px;
}
.sysChatContentTemp {
  flex: 8;
  /*border: 1px solid #ebeff2;*/
  border-radius: 5px 5px 0 0;
  /*margin-left: 1rem;*/
  /*padding-left: 5px;*/
  position: relative;
  height: 100%;
  font-family: "Montserrat", Montserrat, serif;
  font-size: 15px !important;
  max-width: 86%;
  /*padding-top: 5px;*/
}

.fa{
  position: absolute;
  right: -4px;
  top: -2px;
  font-size: larger;
  cursor: pointer;
}


/*.for-close {*/
/*  !*margin: 5px auto;*!*/
/*  background: white;*/
/*  color: black;*/
/*  !*border: 0;*!*/
/*  !*padding: 5px 4px 5px 4px;*!*/
/*  font-size: 16px;*/
/*  font-family: inherit;*/
/*  cursor: pointer;*/
/*  display: block;*/
/*  position: inherit;*/
/*  top: -7px;*/
/*  !* left: -50px; *!*/
/*  right: -20px;*/
/*  border: none;*/
/*}*/
</style>
